export default "__VITE_ASSET__BLss3TZN__"